import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/projects/education/page.tsx");
